import store from '@/store/index'
import router from '@/router/index'
import {logpaths} from '@/libs/sysconst'

export default ()=>{
  let logstate=store.state.user.logstate;
  let rpath=router.currentRoute.matched.length?router.currentRoute.matched[0].path:router.currentRoute.path;
  let path=router.currentRoute.path;
  if(
    logstate===false&&
    (
      logpaths.indexOf(rpath)>-1||
      logpaths.indexOf(path)>-1
    )
  ){
    router.replace ({
      name:'login',
      query:{
        back:router.currentRoute.path
      }
    })
    return false;
  }
  return true;
}